export default "https://cdn-static.gokick.com/assets/3258f73df43fa954b49bc6bd6de466cccdb5fe2c/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";